var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#patternES)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "patternES",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8917_2491",
    transform: "translate(-0.251366) scale(0.00546448)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8917_2491",
    width: 275,
    height: 183,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAIAAAC+MS2jAAAEdUlEQVR4Ae3VsY0CQRBFwfGJAGfzIW8OB5OA9mLoZ7ZKwpw2tqT3OZ/H5UeAwFTgTA+8J0Dg87iU4y+XQBFQTlEzugSUoxwCRUA5Rc3iElCOcggUAeUUNYtLQDnKIVAElFPULC4B5SiHQBFQTlGzuASUoxwCRUA5Rc3iElCOcggUAeUUNYtLQDnKIVAElFPULC4B5SiHQBFQTlGzuASUoxwCRUA5Rc3iElCOcggUAeUUNYtLQDnKIVAElFPULC4B5SiHQBFQTlGzuASUoxwCRUA5Rc3iElCOcggUAeUUNYtLQDnKIVAElFPULC4B5SiHQBFQTlGzuASUoxwCRUA5Rc3iElCOcggUAeUUNYtLQDnKIVAElFPULC4B5SiHQBFQTlGzuATO37n8CBCYCpzf6+lHgMBU4NxfPwIExgLnfvsRIDAWGB8ojQCB+32UQ4BAESg3JocAAeUQIFAEyo29IUBAOQQIFIFyY28IEFAOAQJFoNzYGwIElEOAQBEoN/aGAAHlECBQBMqNvSFAQDkECBSBcmNvCBBQDgECRaDc2BsCBJRDgEARKDf2hgAB5RAgUATKjb0hQEA5BAgUgXJjbwgQUA4BAkWg3NgbAgSUQ4BAESg39oYAAeUQIFAEyo29IUBAOQQIFIFyY28IEFAOAQJFoNzYGwIElEOAQBEoN/aGAAHlECBQBMqNvSFAQDkECBSBcmNvCBBQDgECRaDc2BsCBJRDgEARKDf2hgAB5RAgUATKjb0hQEA5BAgUgXJjbwgQUA4BAkWg3NgbAgSUQ4BAESg39oYAAeUQIFAEyo29IUBAOQQIFIFyY28IEFAOAQJFoNzYGwIElEOAQBEoN/aGAAHlECBQBMqNvSFAQDkECBSBcmNvCBBQDgECRaDc2BsCBJRDgEARKDf2hgAB5RAgUATKjb0hQEA5BAgUgXJjbwgQUA4BAkWg3NgbAgSUQ4BAESg39oYAAeUQIFAEyo29IUBAOQQIFIFyY28IEFAOAQJFoNzYGwIElEOAQBEoN/aGAAHlECBQBMqNvSFAQDkECBSBcmNvCBBQDgECReDcXz8CBMYC5/d6+hEgMBU4f+fyI0BgKnA+j8uPAIGpgHIMB4EioJyiNt0n7/cJKEc5BIqAcoravgX1RVMB5SiHQBFQTlGb7pP3+wSUoxwCRUA5RW3fgvqiqYBylEOgCCinqE33yft9AspRDoEioJyitm9BfdFUQDnKIVAElFPUpvvk/T4B5SiHQBFQTlHbt6C+aCqgHOUQKALKKWrTffJ+n4BylEOgCCinqO1bUF80FVCOcggUAeUUtek+eb9PQDnKIVAElFPU9i2oL5oKKEc5BIqAcoradJ+83yegHOUQKALKKWr7FtQXTQWUoxwCRUA5RW26T97vE1COcggUAeUUtX0L6oumAspRDoEioJyiNt0n7/cJKEc5BIqAcoravgX1RVMB5SiHQBFQTlGb7pP3+wSUoxwCRUA5RW3fgvqiqYBylEOgCCinqE33yft9AspRDoEi8A+R+hYdCqme9wAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/ES.b15f656d01239a32562c19fafe571103.svg";
export { ForwardRef as ReactComponent };